import React, { useState } from 'react';
import { RxCross1 } from 'react-icons/rx';
import apiClient from '../../api/apiClient';
import authServices from '../../services/AuthServices';

import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';

const ChangePassword = ({ isOpen, onClose }) => {


    const [formData, setFormData] = useState({
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",

    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const token = authServices.getToken();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await apiClient.post(`/api/admin/reset_adminpassword`,
                {
                    oldPassword: formData.oldPassword,
                    password: formData.newPassword,
                    confirmPassword: formData.confirmPassword,
                },
                {
                    headers: {
                        Authorization: token,
                        'Content-Type': 'application/json',
                    },
                }
            );
            if (response.data.Status === "SUCCESS") {
                toast.success(response.data.message);
                setFormData({
                    oldPassword: "",
                    newPassword: "",
                    confirmPassword: "",
                });
                onClose();
            }
            else {
                toast.error(response.data.message);
            }

            // Success response ko handle kijiye
        } catch (error) {
            console.error(" CATCH Error Password:", error.response ? error.response.data : error.message);
            toast.error(error.response ? error.response.data.message : error.message);
        }

    };


    if (!isOpen) return null;
    return (
        <>
            <div className="modal-overlay">
                <div className="modal-card2">
                    <div className='d-flex justify-content-between'>
                        <div className=''>
                            <h2 className="modal-title ps-2">Change Password Here</h2>
                        </div>
                        <div>
                            <button className="btn btn-light" onClick={onClose}><RxCross1 /></button>
                        </div>

                    </div>

                    <hr></hr>
                    <div className="container text-start">

                        <form >

                            {/* Bank Ref-Id Field */}
                            <div className="mb-3">
                                <label htmlFor="oldPassword" className="form-label">
                                    Old Password
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="oldPassword"
                                    name="oldPassword"
                                    placeholder="Enter Old Password"
                                    value={formData.oldPassword}
                                    onChange={handleChange}
                                />
                            </div>

                            {/* Bank Ref-Id Field */}
                            <div className="mb-3">
                                <label htmlFor="newPassword" className="form-label">
                                    New Password
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="newPassword"
                                    name="newPassword"
                                    placeholder="Enter New Password"
                                    value={formData.newPassword}
                                    onChange={handleChange}
                                />
                            </div>

                            {/* Bank Ref-Id Field */}
                            <div className="mb-3">
                                <label htmlFor="confirmPassword" className="form-label">
                                    Confirm Password
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="confirmPassword"
                                    name="confirmPassword"
                                    placeholder="Enter Confirm Password"
                                    value={formData.confirmPassword}
                                    onChange={handleChange}
                                />
                            </div>


                            {/* Submit Button */}
                            <button className="btn btn-primary w-100 mt-4" onClick={handleSubmit}>
                                Submit
                            </button>
                        </form>
                    </div>

                </div>
            </div>
        </>
    );
};

export default ChangePassword;
